import { type AxiosError } from 'axios'
import useSwr, { type SWRResponse } from 'swr'

import {
  NotepadControllerV2ApiFactory,
  type NotepadV2Entry,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'

/**
 * if no upid, key will be null, which will cause swr to not fetch
 */
const getLanguageNotepadV2TenantUpidGetQueryKey = (
  upid: string | null,
): string | null =>
  upid ? `LanguageNotepadV2TenantUpidGetQuery-${upid}` : null

export const useLanguageNotepadV2TenantUpidGetQuery = ({
  upid,
}: {
  upid: string | null
}): SWRResponse<NotepadV2Entry | undefined, Error> => {
  const config = useGlobalConfigContext()
  const client = useGlooApi(NotepadControllerV2ApiFactory)

  return useSwr<NotepadV2Entry | undefined, AxiosError>(
    getLanguageNotepadV2TenantUpidGetQueryKey(upid),
    async () => {
      if (!upid) {
        return undefined
      }
      const response = await client.languageNotepadV2TenantUpidGet({
        language: config.language,
        tenant: config.tenantAndEnv,
        upid,
      })

      return response.data
    },
    {
      shouldRetryOnError: false,
    },
  )
}
